import _taggedTemplateLiteral from "@babel/runtime-corejs2/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      width: ", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import styled from 'styled-components';
import { Colors } from '@origin-digital/style-guide';
import { BREAK_POINTS, breakPoint } from '@origin-digital/helper';
import { interaction } from '@origin-digital/reporting-client';
var SELECT_LABEL_OFFSET_PX = 22;
var SelectElement = styled.select.withConfig({
  displayName: "SelectElement",
  componentId: "jibk60-0"
})(["font-family:'gordita',sans-serif;color:", ";border:0;font-size:12px;outline:none;background:transparent;appearance:none;border-radius:0;margin:0;display:block;cursor:pointer;width:", ";margin-right:", "px;padding-right:", "px;", ""], Colors.GREY80, function (_ref) {
  var hidden = _ref.hidden;
  return hidden ? '0' : '100%';
}, function (_ref2) {
  var hidden = _ref2.hidden;
  return hidden ? '-40' : '-20';
}, function (_ref3) {
  var hidden = _ref3.hidden;
  return hidden ? '40' : '20';
}, function () {
  return breakPoint('LG', BREAK_POINTS.LG.Min)(_templateObject(), function (_ref4) {
    var width = _ref4.width;
    return width ? "".concat(width + SELECT_LABEL_OFFSET_PX, "px") : 'auto';
  });
});
export var Select = function Select(props) {
  var hidden = props.hidden,
      onChange = props.onChange,
      options = props.options,
      width = props.width,
      selectedValue = props.selectedValue,
      dataId = props['data-id'];

  var handleOnChange = function handleOnChange(e) {
    interaction('click', {
      componentType: hidden ? 'compact' : 'full',
      id: 'property-selector',
      label: 'property-selector',
      parentContainer: 'action-bar'
    });
    onChange && onChange(e);
  };

  return React.createElement(SelectElement, {
    "data-id": dataId,
    width: width,
    onChange: handleOnChange,
    value: selectedValue,
    hidden: hidden
  }, options.map(function (_ref5, ix) {
    var label = _ref5.label,
        value = _ref5.value;
    return React.createElement("option", {
      value: value,
      key: value || "Select".concat(ix)
    }, label);
  }));
};